import React, { useEffect, useState, useContext } from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { FiInstagram, FiLinkedin, FiFacebook, FiYoutube } from "react-icons/fi";
import { AiFillTikTok } from "react-icons/ai";
import { LanguageContext } from "../../context/LanguageContext";
import axios from "axios";

import footerLogo from "../../assets/images/navbar/voyahCompleteLogo.png";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const CURRENT_YEAR = new Date().getFullYear();

const Footer = () => {
  const { currentLang, texts } = useContext(LanguageContext);
  const [data, setData] = useState(null);

  const resolve = (path) =>
    path?.startsWith("http") ? path : `${API_BASE}${path}`;

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/FooterSection?lang=${currentLang}`,
        );
        setData(res.data);
      } catch (err) {
        console.error("Failed to load footer:", err);
      }
    };

    load();
  }, [currentLang]);

  if (!data) return null;

  return (
    <footer className="voyah-footer">
      {/* LEFT — LOGO + SOCIALS */}
      <div className="footer-col footer-left">
        <div className="footer-logo">
          <img src={footerLogo} alt="Voyah Logo" />
        </div>

        <p className="footer-follow">{data.followUs}</p>

        <div className="footer-socials">
          {data.instagram && (
            <a href={data.instagram} className="footer-icon" target="_blank">
              <FiInstagram />
            </a>
          )}

          {data.linkedin && (
            <a href={data.linkedin} className="footer-icon" target="_blank">
              <FiLinkedin />
            </a>
          )}

          {data.facebook && (
            <a href={data.facebook} className="footer-icon" target="_blank">
              <FiFacebook />
            </a>
          )}

          {data.youtube && (
            <a href={data.youtube} className="footer-icon" target="_blank">
              <FiYoutube />
            </a>
          )}

          {data.tiktok && (
            <a href={data.tiktok} className="footer-icon" target="_blank">
              <AiFillTikTok />
            </a>
          )}
        </div>
      </div>

      {/* MIDDLE 1 — USEFUL LINKS */}
      <div className="footer-col">
        <h3 className="footer-title">{data.usefulLinksTitle}</h3>

        <Link to="/testdrive" className="footer-link">
          {data.useful1}
        </Link>
        <Link to="/campaigns" className="footer-link">
          {data.useful2}
        </Link>
        <Link to="/showroom" className="footer-link">
          {data.useful3}
        </Link>
        <Link to="/contact" className="footer-link">
          {texts.contact?.footerLink || "Contact us"}
        </Link>
      </div>

      {/* MIDDLE 2 — TECH SPECS */}
      <div className="footer-col">
        <h3 className="footer-title">{data.techTitle}</h3>

        <Link to="/voyah-free" className="footer-link">
          {data.tech1}
        </Link>
        <Link to="/voyah-dream" className="footer-link">
          {data.tech2}
        </Link>
      </div>

      {/* RIGHT — WARRANTY BOX */}
      <div className="warranty-box">
        <h3>{data.warrantyTitle}</h3>

        <p className="w-big">{data.block1Big}</p>
        <p className="w-small">{data.block1Small}</p>

        <p className="w-big">{data.block2Big}</p>
        <p className="w-small">{data.block2Small}</p>
      </div>

      {/* BOTTOM ROW */}
      <div className="footer-bottom">
        <div className="footer-bottom-links">
          <p>©{CURRENT_YEAR}</p>
          <Link to="/about-us" className="footer-bottom-link">{data.about}</Link>
          <Link className="footer-bottom-link">{data.privacy}</Link>
        </div>

        <a
          href="https://vuca.li/"
          target="_blank"
          rel="noopener noreferrer"
          className="comp"
        >
          <img
            className="compFoot"
            src={resolve(data.logo)}
            alt="Company Logo"
          />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
